import { render, staticRenderFns } from "./VolunteerHours.vue?vue&type=template&id=a98134d6"
import script from "./VolunteerHours.vue?vue&type=script&lang=ts"
export * from "./VolunteerHours.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports